import { render, staticRenderFns } from "./SwapCancellationPanel.vue?vue&type=template&id=a79f2d06&scoped=true"
import script from "./SwapCancellationPanel.vue?vue&type=script&lang=js"
export * from "./SwapCancellationPanel.vue?vue&type=script&lang=js"
import style0 from "./SwapCancellationPanel.vue?vue&type=style&index=0&id=a79f2d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79f2d06",
  null
  
)

export default component.exports